import { formatCurrency } from '@/utils/formatCurrency'
import { formatDateShort } from '@/utils/formatDate'

export const CHART_BAR_MAX_HEIGHT = 194
export const CHART_FILL_RATIO = 0.85
export const EMPTY_DATA_PLACEHOLDER_COUNT = 7

export interface DailyRevenue {
  date: string
  revenue: string | number
}

/**
 * 纯逻辑：将处理后的图表数据映射为最终显示项
 */
export function mapRevenueToChartItems(
  sourceData: any[],
  maxAmount: number,
  isPlaceholder = false,
) {
  const safeMaxAmount = maxAmount > 0 ? maxAmount : 1
  const multiplier = maxAmount > 0 && !isPlaceholder ? 1 : 0

  return sourceData.map((item, index) => {
    const amount = isPlaceholder ? 0 : Number(item.revenue)
    return {
      date: isPlaceholder ? `Day${index + 1}` : formatDateShort(item.date),
      value: isPlaceholder ? '--' : item.revenue,
      amount: amount,
      isLastItem: index === sourceData.length - 1,
      barHeight:
        (amount / safeMaxAmount) *
        CHART_BAR_MAX_HEIGHT *
        CHART_FILL_RATIO *
        multiplier,
    }
  })
}

/**
 * 纯逻辑：计算月份名称 (上个月)
 */
export function getPreviousMonthName() {
  return new Date(
    new Date().getFullYear(),
    new Date().getMonth() - 1,
  ).toLocaleString('en-US', { month: 'long' })
}

/**
 * 纯逻辑：格式化收益汇总
 */
export function formatRevenueDisplay(amount?: string | number) {
  if (amount === undefined || amount === null) return '--'
  return formatCurrency(Number(amount))
}
